import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-xhr-backend';
import { API } from './constants';
const base = window.REACT_APP_BASE_API;
i18n
    .use(Backend)
    .use(initReactI18next)
    .init({
        lng: 'en',
        fallbackLng: 'en',
        backend: {
            loadPath: `${base ?? API.url}/locales/{{lng}}`
        },
        debug: true
    });

export default i18n;
